import { UPDATE_GEO_ADDRESS } from '../actions'

export default function (state = {}, action) {
    switch (action.type) {
        case UPDATE_GEO_ADDRESS:
            console.log("GET",action.payload)
            return action.payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/geo_location_reducer.js